// extracted by mini-css-extract-plugin
module.exports = {"versionHistory":"VersionHistory_versionHistory__Udy1v","spinnerContainer":"VersionHistory_spinnerContainer__Uv27V"};